import { useDataModel } from '@thd-nucleus/data-sources';
import { useConfigService } from '@thd-nucleus/experience-context';

export const useCategoryCard = ({
  clientStore,
  store,
  storeId,
  keyword,
  navParam,
  propLoading,
  propData,
  propError,
  ssr
}) => {
  const isContentServiceEnabled = useConfigService('fs:isContentServiceEnabled');

  const { storeId: defaultStoreId } = clientStore || store;
  const variables = {
    storeId: storeId || defaultStoreId,
  };
  if (keyword) {
    variables.keyword = keyword;
  }
  if (navParam) {
    variables.navParam = navParam;
  }
  const isPropDriven = typeof propLoading !== 'undefined';
  const skip = (propData || propLoading || propError) || (!keyword && !navParam && !isPropDriven);

  let { data, loading, error } = useDataModel('searchModel', {
    variables,
    skip,
    ssr
  });

  if (propData || propLoading || propError) {
    data = propData;
    loading = propLoading;
    error = propError;
  }
  const shouldSkipGetContentCall = !isContentServiceEnabled || (!navParam && !keyword);

  const { data: contentData, loading: contentLoading } = useDataModel('getContent', {
    variables: { query: navParam || keyword },
    ssr: true,
    skip: shouldSkipGetContentCall,
    fetchPolicy: 'cache-first',
  });

  if (isContentServiceEnabled) {
    return {
      data: (data || contentData) ? { ...data, ...contentData } : null,
      loading: (loading || contentLoading),
      error
    };
  }

  return { data, loading, error };
};
